import {
    FBInit,
    FBLogin,
    FBLogout,
    FBGetAuthQuery,
    FBCheckAuthStatus,
} from './fb'

import {
    GoogleInit,
    GoogleLogin,
    GoogleLogout,
    GoogleGetAuthQuery,
    GoogleCheckAuthStatus,
} from './google'

export default {
    init,
    login,
    logout,
    getAuthQs,
    checkAuthStatus,
    saveSession,
    removeSession,
    getSession,
}

const DEFAULT_TYPE = 'facebook'

async function init() {
    FBInit()
    await GoogleInit()
}

function getAuthQs(type) {
    // load
    if (!type) {
        type = getSession()
    }

    let getAuthQsFn

    switch (type) {
        case 'google':
            getAuthQsFn = GoogleGetAuthQuery
            break

        default:
            // facebook
            getAuthQsFn = FBGetAuthQuery
            break
    }

    const auth = getAuthQsFn()
    return auth
}

async function login(type = DEFAULT_TYPE) {
    let loginFn

    switch (type) {
        case 'google':
            loginFn = GoogleLogin
            break

        default:
            // facebook
            loginFn = FBLogin
            break
    }

    const user = await loginFn()
    return user
}

async function logout() {
    let logoutFn

    // load
    let type = getSession()
    if (!type) {
        type = DEFAULT_TYPE
    }

    switch (type) {
        case 'google':
            logoutFn = GoogleLogout
            break

        default:
            // facebook
            logoutFn = FBLogout
            break
    }

    await logoutFn()
    removeSession()
    return
}

async function checkAuthStatus() {
    let fn

    // load
    let type = getSession()
    if (!type) {
        type = DEFAULT_TYPE
    }

    switch (type) {
        case 'google':
            fn = GoogleCheckAuthStatus
            break

        default:
            // facebook
            fn = FBCheckAuthStatus
            break
    }

    const ok = await fn()
    return ok
}

function saveSession(type) {
    if (!type) {
        return
    }
    localStorage.setItem('auth_type', type)
}

function removeSession() {
    localStorage.removeItem('auth_type')
}

function getSession() {
    const type = localStorage.getItem('auth_type')
    return type ? type : ''
}